import type { AiAppCenterModule } from '../types'

export const travelModule: AiAppCenterModule = {
  key: 'travel',
  label: '旅游管理',
  desc: '旅游线路 / 套餐配置 / 订单管理',
  path: '/travel',
  homePath: '/travel/dashboard',
  icon: 'ep:map-location',
  color: '#14b8a6',
  aliases: ['旅游平台']
}
